import * as _ from "lodash";

export const FONT_SIZE_LIST = [16, 18, 20, 24, 28, 32, 36, 48, 64, 72, 96, 144, 256];
export const DEFAULT_MOVE_STEP = 10;
export const DEFAULT_USED_FONT_SIZE_LIST = [96];
export const DEFAULT_USED_FONT_LIST = [
    {
        fontName: "Aiushtya",
        fontKey: "Aiushtya"
    }];

export const DEFAULT_FONT = {
    fontSize: 48,
    fontFamily: "Aiushtya"
};

export const FONT_FAMILY_LIST = [
    {
        "fontName": "Aaron Ramsey Italic",
        "fontKey": "AaronRamseyItalic"
    },
    {
        "fontName": "Aaron Ramsey",
        "fontKey": "AaronRamsey"
    },
    {
        "fontName": "Adelia Rehan",
        "fontKey": "AdeliaRehan"
    },
    {
        "fontName": "Agathis",
        "fontKey": "Agathis"
    },
    {
        "fontName": "Aiushtya",
        "fontKey": "Aiushtya"
    },
    {
        "fontName": "Akira Rosty Normal",
        "fontKey": "AkiraRostyNormal"
    },
    {
        "fontName": "Akira Rosty with love",
        "fontKey": "AkiraRostyWithLove"
    },
    {
        "fontName": "Albertya TT",
        "fontKey": "AlbertyaTt"
    },
    {
        "fontName": "Albertya",
        "fontKey": "Albertya"
    },
    {
        "fontName": "Alexia Bright Sans",
        "fontKey": "AlexiaBrightSans"
    },
    {
        "fontName": "Alexia Bright Script",
        "fontKey": "AlexiaBrightScript"
    },
    {
        "fontName": "Alive",
        "fontKey": "Alive"
    },
    {
        "fontName": "Aliyah",
        "fontKey": "Aliyah"
    },
    {
        "fontName": "Allenisa",
        "fontKey": "Allenisa"
    },
    {
        "fontName": "AllenisaItalic",
        "fontKey": "AllenisaItalic"
    },
    {
        "fontName": "Alothea",
        "fontKey": "Alothea"
    },
    {
        "fontName": "AlphabetFont",
        "fontKey": "AlphabetFont"
    },
    {
        "fontName": "Always Better",
        "fontKey": "AlwaysBetter"
    },
    {
        "fontName": "AmberWhiskey Aged",
        "fontKey": "AmberWhiskeyAged"
    },
    {
        "fontName": "AmberWhiskey FullColor",
        "fontKey": "AmberWhiskeyFullColor"
    },
    {
        "fontName": "AmberWhiskey Shadow",
        "fontKey": "AmberWhiskeyShadow"
    },
    {
        "fontName": "AmberWhiskey",
        "fontKey": "AmberWhiskey"
    },
    {
        "fontName": "Amellyta",
        "fontKey": "Amellyta"
    },
    {
        "fontName": "Ameston Outline",
        "fontKey": "AmestonOutline"
    },
    {
        "fontName": "Ameston Sans",
        "fontKey": "AmestonSans"
    },
    {
        "fontName": "Ameston",
        "fontKey": "Ameston"
    },
    {
        "fontName": "Anatomi Underlines",
        "fontKey": "AnatomiUnderlines"
    },
    {
        "fontName": "Anatomi",
        "fontKey": "Anatomi"
    },
    {
        "fontName": "Andesia",
        "fontKey": "Andesia"
    },
    {
        "fontName": "Andy Bear",
        "fontKey": "AndyBear"
    },
    {
        "fontName": "Angolla",
        "fontKey": "Angolla"
    },
    {
        "fontName": "Anime",
        "fontKey": "Anime"
    },
    {
        "fontName": "Antemowa",
        "fontKey": "Antemowa"
    },
    {
        "fontName": "Antiqueline",
        "fontKey": "Antiqueline"
    },
    {
        "fontName": "Anybella",
        "fontKey": "Anybella"
    },
    {
        "fontName": "Anybody",
        "fontKey": "Anybody"
    },
    {
        "fontName": "Arjunka",
        "fontKey": "Arjunka"
    },
    {
        "fontName": "Arkusi",
        "fontKey": "Arkusi"
    },
    {
        "fontName": "Armor",
        "fontKey": "Armor"
    },
    {
        "fontName": "Armouk Regular",
        "fontKey": "ArmoukRegular"
    },
    {
        "fontName": "Arshaka",
        "fontKey": "Arshaka"
    },
    {
        "fontName": "Asmbuh",
        "fontKey": "Asmbuh"
    },
    {
        "fontName": "AsmbuhItalic",
        "fontKey": "AsmbuhItalic"
    },
    {
        "fontName": "Attaira Sans",
        "fontKey": "AttairaSans"
    },
    {
        "fontName": "Attaira",
        "fontKey": "Attaira"
    },
    {
        "fontName": "Audrey",
        "fontKey": "Audrey"
    },
    {
        "fontName": "Austina",
        "fontKey": "Austina"
    },
    {
        "fontName": "Autumn Monoline",
        "fontKey": "AutumnMonoline"
    },
    {
        "fontName": "Ayana",
        "fontKey": "Ayana"
    },
    {
        "fontName": "BIRTLOVE",
        "fontKey": "Birtlove"
    },
    {
        "fontName": "BIRTLOVEitalic",
        "fontKey": "BirtlovEitalic"
    },
    {
        "fontName": "Baby Angelonia",
        "fontKey": "BabyAngelonia"
    },
    {
        "fontName": "Baby Gurita Vintage 1",
        "fontKey": "BabyGuritaVintage1"
    },
    {
        "fontName": "Baby Gurita",
        "fontKey": "BabyGurita"
    },
    {
        "fontName": "Baby Mentani",
        "fontKey": "BabyMentani"
    },
    {
        "fontName": "Baby",
        "fontKey": "Baby"
    },
    {
        "fontName": "Babylonia Underlines",
        "fontKey": "BabyloniaUnderlines"
    },
    {
        "fontName": "Babylonia",
        "fontKey": "Babylonia"
    },
    {
        "fontName": "Baginda",
        "fontKey": "Baginda"
    },
    {
        "fontName": "Barley Regular",
        "fontKey": "BarleyRegular"
    },
    {
        "fontName": "BarleyAged Regular",
        "fontKey": "BarleyAgedRegular"
    },
    {
        "fontName": "BarleyRough Regular",
        "fontKey": "BarleyRoughRegular"
    },
    {
        "fontName": "Barstrip Bold",
        "fontKey": "BarstripBold"
    },
    {
        "fontName": "Barstrip",
        "fontKey": "Barstrip"
    },
    {
        "fontName": "Baseball",
        "fontKey": "Baseball"
    },
    {
        "fontName": "Beach",
        "fontKey": "Beach"
    },
    {
        "fontName": "BeautifulVariella",
        "fontKey": "BeautifulVariella"
    },
    {
        "fontName": "Beauty And Love Script",
        "fontKey": "BeautyAndLoveScript"
    },
    {
        "fontName": "Beauty and Love Dingbat",
        "fontKey": "BeautyAndLoveDingbat"
    },
    {
        "fontName": "Beauty and Love Sans",
        "fontKey": "BeautyAndLoveSans"
    },
    {
        "fontName": "Belalang",
        "fontKey": "Belalang"
    },
    {
        "fontName": "Belgia",
        "fontKey": "Belgia"
    },
    {
        "fontName": "Berrylove",
        "fontKey": "Berrylove"
    },
    {
        "fontName": "BerryloveITALIC",
        "fontKey": "BerryloveItalic"
    },
    {
        "fontName": "BesideRegular",
        "fontKey": "BesideRegular"
    },
    {
        "fontName": "Besthie",
        "fontKey": "Besthie"
    },
    {
        "fontName": "BesthieItalic",
        "fontKey": "BesthieItalic"
    },
    {
        "fontName": "Bestie",
        "fontKey": "Bestie"
    },
    {
        "fontName": "Bestworde",
        "fontKey": "Bestworde"
    },
    {
        "fontName": "BestwordeItalic",
        "fontKey": "BestwordeItalic"
    },
    {
        "fontName": "Betana Script",
        "fontKey": "BetanaScript"
    },
    {
        "fontName": "Better Days",
        "fontKey": "BetterDays"
    },
    {
        "fontName": "Better Together",
        "fontKey": "BetterTogether"
    },
    {
        "fontName": "Betteryou",
        "fontKey": "Betteryou"
    },
    {
        "fontName": "Bible",
        "fontKey": "Bible"
    },
    {
        "fontName": "BigloveFONT",
        "fontKey": "BigloveFont"
    },
    {
        "fontName": "BigloveFONTItalic",
        "fontKey": "BigloveFontItalic"
    },
    {
        "fontName": "BiolinaLarasita",
        "fontKey": "BiolinaLarasita"
    },
    {
        "fontName": "Biscuit",
        "fontKey": "Biscuit"
    },
    {
        "fontName": "Bitterlove",
        "fontKey": "Bitterlove"
    },
    {
        "fontName": "Black Panther underlines",
        "fontKey": "BlackPantherUnderlines"
    },
    {
        "fontName": "Black Panther",
        "fontKey": "BlackPanther"
    },
    {
        "fontName": "Black Panthert underlines",
        "fontKey": "BlackPanthertUnderlines"
    },
    {
        "fontName": "BlackCatthie",
        "fontKey": "BlackCatthie"
    },
    {
        "fontName": "BlackThunder",
        "fontKey": "BlackThunder"
    },
    {
        "fontName": "Blacksugar",
        "fontKey": "Blacksugar"
    },
    {
        "fontName": "Blush Script",
        "fontKey": "BlushScript"
    },
    {
        "fontName": "BlushScript",
        "fontKey": "BlushScript"
    },
    {
        "fontName": "Boho Font Filled",
        "fontKey": "BohoFontFilled"
    },
    {
        "fontName": "Boho Font Lined",
        "fontKey": "BohoFontLined"
    },
    {
        "fontName": "Boldest Decorative",
        "fontKey": "BoldestDecorative"
    },
    {
        "fontName": "Boldest",
        "fontKey": "Boldest"
    },
    {
        "fontName": "Boldline",
        "fontKey": "Boldline"
    },
    {
        "fontName": "Bornena",
        "fontKey": "Bornena"
    },
    {
        "fontName": "Bosterina",
        "fontKey": "Bosterina"
    },
    {
        "fontName": "Braylen",
        "fontKey": "Braylen"
    },
    {
        "fontName": "Break Love Font",
        "fontKey": "BreakLoveFont"
    },
    {
        "fontName": "Break Love",
        "fontKey": "BreakLove"
    },
    {
        "fontName": "Bright Burn 2",
        "fontKey": "BrightBurn2"
    },
    {
        "fontName": "Bright Burn Brush",
        "fontKey": "BrightBurnBrush"
    },
    {
        "fontName": "Bright Burn",
        "fontKey": "BrightBurn"
    },
    {
        "fontName": "BrillianaMonogram",
        "fontKey": "BrillianaMonogram"
    },
    {
        "fontName": "Brooklyn Bold 1",
        "fontKey": "BrooklynBold1"
    },
    {
        "fontName": "Brooklyn BoldItalic",
        "fontKey": "BrooklynBoldItalic"
    },
    {
        "fontName": "Brooklyn Heavy 1",
        "fontKey": "BrooklynHeavy1"
    },
    {
        "fontName": "Brooklyn HeavyItalic",
        "fontKey": "BrooklynHeavyItalic"
    },
    {
        "fontName": "Brooklyn Italic",
        "fontKey": "BrooklynItalic"
    },
    {
        "fontName": "Brooklyn Normal 1",
        "fontKey": "BrooklynNormal1"
    },
    {
        "fontName": "Brooklyn SemiBold",
        "fontKey": "BrooklynSemiBold"
    },
    {
        "fontName": "Brooklyn SemiBoldItalic",
        "fontKey": "BrooklynSemiBoldItalic"
    },
    {
        "fontName": "BrushSplash",
        "fontKey": "BrushSplash"
    },
    {
        "fontName": "Bugermavle",
        "fontKey": "Bugermavle"
    },
    {
        "fontName": "Bunnyheart",
        "fontKey": "Bunnyheart"
    },
    {
        "fontName": "Busther",
        "fontKey": "Busther"
    },
    {
        "fontName": "Butterfly Garden",
        "fontKey": "ButterflyGarden"
    },
    {
        "fontName": "Butterfly Monogram",
        "fontKey": "ButterflyMonogram"
    },
    {
        "fontName": "COUPLELOVEMONOGRAM Left",
        "fontKey": "CouplelovemonogramLeft"
    },
    {
        "fontName": "COUPLELOVEMONOGRAM Right",
        "fontKey": "CouplelovemonogramRight"
    },
    {
        "fontName": "CRASH",
        "fontKey": "Crash"
    },
    {
        "fontName": "Cable beach",
        "fontKey": "CableBeach"
    },
    {
        "fontName": "Caligraphy",
        "fontKey": "Caligraphy"
    },
    {
        "fontName": "CampingGround",
        "fontKey": "CampingGround"
    },
    {
        "fontName": "Celestial Script",
        "fontKey": "CelestialScript"
    },
    {
        "fontName": "Celestial",
        "fontKey": "Celestial"
    },
    {
        "fontName": "Chayton",
        "fontKey": "Chayton"
    },
    {
        "fontName": "Cheering Mood",
        "fontKey": "CheeringMood"
    },
    {
        "fontName": "Chicago Darling Serif",
        "fontKey": "ChicagoDarlingSerif"
    },
    {
        "fontName": "Child",
        "fontKey": "Child"
    },
    {
        "fontName": "Chilli",
        "fontKey": "Chilli"
    },
    {
        "fontName": "ChristWhiteFONT",
        "fontKey": "ChristWhiteFont"
    },
    {
        "fontName": "ChristWhiteFONTITALIC",
        "fontKey": "ChristWhiteFontitalic"
    },
    {
        "fontName": "ChristhineFONT",
        "fontKey": "ChristhineFont"
    },
    {
        "fontName": "ChristhineFONTItalic",
        "fontKey": "ChristhineFontItalic"
    },
    {
        "fontName": "ChristianoFONT",
        "fontKey": "ChristianoFont"
    },
    {
        "fontName": "ChristianoFONTItalic",
        "fontKey": "ChristianoFontItalic"
    },
    {
        "fontName": "Christmas Heart",
        "fontKey": "ChristmasHeart"
    },
    {
        "fontName": "Christmas winter",
        "fontKey": "ChristmasWinter"
    },
    {
        "fontName": "ChristmasCraftFONT",
        "fontKey": "ChristmasCraftFont"
    },
    {
        "fontName": "ChristmasCraftFONTBold",
        "fontKey": "ChristmasCraftFontBold"
    },
    {
        "fontName": "ChristmasCraftFONTItalic",
        "fontKey": "ChristmasCraftFontItalic"
    },
    {
        "fontName": "ChristmasShineFONT",
        "fontKey": "ChristmasShineFont"
    },
    {
        "fontName": "ChristmasShineFONTItalic",
        "fontKey": "ChristmasShineFontItalic"
    },
    {
        "fontName": "ChristmasWeatherFONT",
        "fontKey": "ChristmasWeatherFont"
    },
    {
        "fontName": "ChristmasWeatherFONTItalic",
        "fontKey": "ChristmasWeatherFontItalic"
    },
    {
        "fontName": "Christova",
        "fontKey": "Christova"
    },
    {
        "fontName": "ChristovaITALIC",
        "fontKey": "ChristovaItalic"
    },
    {
        "fontName": "Chubby",
        "fontKey": "Chubby"
    },
    {
        "fontName": "Circuitra",
        "fontKey": "Circuitra"
    },
    {
        "fontName": "Clowney",
        "fontKey": "Clowney"
    },
    {
        "fontName": "ColorLetters SVG",
        "fontKey": "ColorLettersSvg"
    },
    {
        "fontName": "Colorfulsummer Highlight",
        "fontKey": "ColorfulsummerHighlight"
    },
    {
        "fontName": "Colorfulsummer",
        "fontKey": "Colorfulsummer"
    },
    {
        "fontName": "Comic Toon",
        "fontKey": "ComicToon"
    },
    {
        "fontName": "Corlita Sans",
        "fontKey": "CorlitaSans"
    },
    {
        "fontName": "Corlita Script",
        "fontKey": "CorlitaScript"
    },
    {
        "fontName": "Corlita Serif",
        "fontKey": "CorlitaSerif"
    },
    {
        "fontName": "Country",
        "fontKey": "Country"
    },
    {
        "fontName": "CountryKitchen",
        "fontKey": "CountryKitchen"
    },
    {
        "fontName": "Crava",
        "fontKey": "Crava"
    },
    {
        "fontName": "CrayoSketch",
        "fontKey": "CrayoSketch"
    },
    {
        "fontName": "Cruch Branch Outline",
        "fontKey": "CruchBranchOutline"
    },
    {
        "fontName": "Cruch Branch Regular",
        "fontKey": "CruchBranchRegular"
    },
    {
        "fontName": "DaisyLove",
        "fontKey": "DaisyLove"
    },
    {
        "fontName": "Darkrise",
        "fontKey": "Darkrise"
    },
    {
        "fontName": "Darmais",
        "fontKey": "Darmais"
    },
    {
        "fontName": "Daylight Outline",
        "fontKey": "DaylightOutline"
    },
    {
        "fontName": "Daylight",
        "fontKey": "Daylight"
    },
    {
        "fontName": "Daysha",
        "fontKey": "Daysha"
    },
    {
        "fontName": "Dea Githa",
        "fontKey": "DeaGitha"
    },
    {
        "fontName": "Delacruz",
        "fontKey": "Delacruz"
    },
    {
        "fontName": "Dellina",
        "fontKey": "Dellina"
    },
    {
        "fontName": "Demon Hunther",
        "fontKey": "DemonHunther"
    },
    {
        "fontName": "Designer",
        "fontKey": "Designer"
    },
    {
        "fontName": "Digitechno",
        "fontKey": "Digitechno"
    },
    {
        "fontName": "Dino",
        "fontKey": "Dino"
    },
    {
        "fontName": "DinoZone",
        "fontKey": "DinoZone"
    },
    {
        "fontName": "Dinosaur",
        "fontKey": "Dinosaur"
    },
    {
        "fontName": "DinosaurAlt",
        "fontKey": "DinosaurAlt"
    },
    {
        "fontName": "Dirty Rock",
        "fontKey": "DirtyRock"
    },
    {
        "fontName": "Donut",
        "fontKey": "Donut"
    },
    {
        "fontName": "Drippy",
        "fontKey": "Drippy"
    },
    {
        "fontName": "EarlyChristmas",
        "fontKey": "EarlyChristmas"
    },
    {
        "fontName": "EarlyChristmasItalic",
        "fontKey": "EarlyChristmasItalic"
    },
    {
        "fontName": "Easter Story",
        "fontKey": "EasterStory"
    },
    {
        "fontName": "Easy Style",
        "fontKey": "EasyStyle"
    },
    {
        "fontName": "Elvino",
        "fontKey": "Elvino"
    },
    {
        "fontName": "EmikaDanely",
        "fontKey": "EmikaDanely"
    },
    {
        "fontName": "Endogan",
        "fontKey": "Endogan"
    },
    {
        "fontName": "Eurolite Circle Logo Creator",
        "fontKey": "EuroliteCircleLogoCreator"
    },
    {
        "fontName": "Eurolite",
        "fontKey": "Eurolite"
    },
    {
        "fontName": "Evelyne",
        "fontKey": "Evelyne"
    },
    {
        "fontName": "Everleigh Script",
        "fontKey": "EverleighScript"
    },
    {
        "fontName": "Everleigh",
        "fontKey": "Everleigh"
    },
    {
        "fontName": "Extras",
        "fontKey": "Extras"
    },
    {
        "fontName": "Faded",
        "fontKey": "Faded"
    },
    {
        "fontName": "Fadhillah Signature",
        "fontKey": "FadhillahSignature"
    },
    {
        "fontName": "Fairy Tail",
        "fontKey": "FairyTail"
    },
    {
        "fontName": "Family Farmhouse Extras Regular",
        "fontKey": "FamilyFarmhouseExtrasRegular"
    },
    {
        "fontName": "Family Farmhouse Script Regular",
        "fontKey": "FamilyFarmhouseScriptRegular"
    },
    {
        "fontName": "Family farmhouse Regular",
        "fontKey": "FamilyFarmhouseRegular"
    },
    {
        "fontName": "Family",
        "fontKey": "Family"
    },
    {
        "fontName": "FancyComicFontBy7NTypes",
        "fontKey": "FancyComicFontBy7NTypes"
    },
    {
        "fontName": "Fatbun Regular",
        "fontKey": "FatbunRegular"
    },
    {
        "fontName": "FathersDay",
        "fontKey": "FathersDay"
    },
    {
        "fontName": "Faylake Rough",
        "fontKey": "FaylakeRough"
    },
    {
        "fontName": "Faylake",
        "fontKey": "Faylake"
    },
    {
        "fontName": "Febriella 3",
        "fontKey": "Febriella3"
    },
    {
        "fontName": "FebriellaMonogram 3",
        "fontKey": "FebriellaMonogram3"
    },
    {
        "fontName": "Feisty Bright",
        "fontKey": "FeistyBright"
    },
    {
        "fontName": "Feraldine Script",
        "fontKey": "FeraldineScript"
    },
    {
        "fontName": "Feraldine",
        "fontKey": "Feraldine"
    },
    {
        "fontName": "Finger",
        "fontKey": "Finger"
    },
    {
        "fontName": "Firstlove",
        "fontKey": "Firstlove"
    },
    {
        "fontName": "Fishbone",
        "fontKey": "Fishbone"
    },
    {
        "fontName": "Florita Sans Bold",
        "fontKey": "FloritaSansBold"
    },
    {
        "fontName": "Florita Sans Medium",
        "fontKey": "FloritaSansMedium"
    },
    {
        "fontName": "Florita Sans",
        "fontKey": "FloritaSans"
    },
    {
        "fontName": "Florita Signature",
        "fontKey": "FloritaSignature"
    },
    {
        "fontName": "Flower Spring",
        "fontKey": "FlowerSpring"
    },
    {
        "fontName": "Flying Soul",
        "fontKey": "FlyingSoul"
    },
    {
        "fontName": "Fonsera",
        "fontKey": "Fonsera"
    },
    {
        "fontName": "FreshLemonade",
        "fontKey": "FreshLemonade"
    },
    {
        "fontName": "Fronds Getturing Extras",
        "fontKey": "FrondsGetturingExtras"
    },
    {
        "fontName": "Fronds Getturing",
        "fontKey": "FrondsGetturing"
    },
    {
        "fontName": "Fun Comics",
        "fontKey": "FunComics"
    },
    {
        "fontName": "Funk Fact",
        "fontKey": "FunkFact"
    },
    {
        "fontName": "Gabriella",
        "fontKey": "Gabriella"
    },
    {
        "fontName": "Garis Lengkung",
        "fontKey": "GarisLengkung"
    },
    {
        "fontName": "Geollitta",
        "fontKey": "Geollitta"
    },
    {
        "fontName": "GhostFlamesFONT",
        "fontKey": "GhostFlamesFont"
    },
    {
        "fontName": "GhostFlamesFONTItalic",
        "fontKey": "GhostFlamesFontItalic"
    },
    {
        "fontName": "Giant Boom",
        "fontKey": "GiantBoom"
    },
    {
        "fontName": "Gidget",
        "fontKey": "Gidget"
    },
    {
        "fontName": "Girl",
        "fontKey": "Girl"
    },
    {
        "fontName": "Glamour",
        "fontKey": "Glamour"
    },
    {
        "fontName": "Glamoury",
        "fontKey": "Glamoury"
    },
    {
        "fontName": "Graduation",
        "fontKey": "Graduation"
    },
    {
        "fontName": "Grandmora",
        "fontKey": "Grandmora"
    },
    {
        "fontName": "Groovy Retro Extrude",
        "fontKey": "GroovyRetroExtrude"
    },
    {
        "fontName": "Groovy Retro",
        "fontKey": "GroovyRetro"
    },
    {
        "fontName": "Groovy Script Extrude",
        "fontKey": "GroovyScriptExtrude"
    },
    {
        "fontName": "Groovy Script",
        "fontKey": "GroovyScript"
    },
    {
        "fontName": "Groovy Yellow Outline",
        "fontKey": "GroovyYellowOutline"
    },
    {
        "fontName": "Groovy Yellow",
        "fontKey": "GroovyYellow"
    },
    {
        "fontName": "HalloweenMonoline",
        "fontKey": "HalloweenMonoline"
    },
    {
        "fontName": "HalloweenMonolineItalic",
        "fontKey": "HalloweenMonolineItalic"
    },
    {
        "fontName": "Hamidha",
        "fontKey": "Hamidha"
    },
    {
        "fontName": "Hamilton",
        "fontKey": "Hamilton"
    },
    {
        "fontName": "Handitype",
        "fontKey": "Handitype"
    },
    {
        "fontName": "Handmade",
        "fontKey": "Handmade"
    },
    {
        "fontName": "Handodle",
        "fontKey": "Handodle"
    },
    {
        "fontName": "Hannah Script",
        "fontKey": "HannahScript"
    },
    {
        "fontName": "Happy",
        "fontKey": "Happy"
    },
    {
        "fontName": "HappyCactus",
        "fontKey": "HappyCactus"
    },
    {
        "fontName": "Haulura",
        "fontKey": "Haulura"
    },
    {
        "fontName": "Havina",
        "fontKey": "Havina"
    },
    {
        "fontName": "Hawaii Shadow",
        "fontKey": "HawaiiShadow"
    },
    {
        "fontName": "Hawaii",
        "fontKey": "Hawaii"
    },
    {
        "fontName": "Haydena",
        "fontKey": "Haydena"
    },
    {
        "fontName": "Hearthline",
        "fontKey": "Hearthline"
    },
    {
        "fontName": "HearthlineITALIC",
        "fontKey": "HearthlineItalic"
    },
    {
        "fontName": "Hello Della",
        "fontKey": "HelloDella"
    },
    {
        "fontName": "Hello Eisya Sans",
        "fontKey": "HelloEisyaSans"
    },
    {
        "fontName": "Hello Eisya",
        "fontKey": "HelloEisya"
    },
    {
        "fontName": "Hey Jintan",
        "fontKey": "HeyJintan"
    },
    {
        "fontName": "HeyBeach",
        "fontKey": "HeyBeach"
    },
    {
        "fontName": "High Mount",
        "fontKey": "HighMount"
    },
    {
        "fontName": "Hillarie",
        "fontKey": "Hillarie"
    },
    {
        "fontName": "Holidate",
        "fontKey": "Holidate"
    },
    {
        "fontName": "Holindya Sephalie",
        "fontKey": "HolindyaSephalie"
    },
    {
        "fontName": "HomeLemonade Print 1",
        "fontKey": "HomeLemonadePrint1"
    },
    {
        "fontName": "HomeLemonade Script 1",
        "fontKey": "HomeLemonadeScript1"
    },
    {
        "fontName": "Honey Berry",
        "fontKey": "HoneyBerry"
    },
    {
        "fontName": "HoneyChristmasFONT",
        "fontKey": "HoneyChristmasFont"
    },
    {
        "fontName": "HoneyChristmasItalicFONT",
        "fontKey": "HoneyChristmasItalicFont"
    },
    {
        "fontName": "HoneyChristmasMonoline",
        "fontKey": "HoneyChristmasMonoline"
    },
    {
        "fontName": "HoneyChristmasMonolineItalic",
        "fontKey": "HoneyChristmasMonolineItalic"
    },
    {
        "fontName": "Honeylovebunny",
        "fontKey": "Honeylovebunny"
    },
    {
        "fontName": "Horstail",
        "fontKey": "Horstail"
    },
    {
        "fontName": "Hostania Oblique",
        "fontKey": "HostaniaOblique"
    },
    {
        "fontName": "Hostania",
        "fontKey": "Hostania"
    },
    {
        "fontName": "Household",
        "fontKey": "Household"
    },
    {
        "fontName": "Husband",
        "fontKey": "Husband"
    },
    {
        "fontName": "I Love Glitter",
        "fontKey": "ILoveGlitter"
    },
    {
        "fontName": "Irendy",
        "fontKey": "Irendy"
    },
    {
        "fontName": "Jaggielka",
        "fontKey": "Jaggielka"
    },
    {
        "fontName": "Jellyhoney",
        "fontKey": "Jellyhoney"
    },
    {
        "fontName": "JoyFriends",
        "fontKey": "JoyFriends"
    },
    {
        "fontName": "Juhaira",
        "fontKey": "Juhaira"
    },
    {
        "fontName": "Jumpheart",
        "fontKey": "Jumpheart"
    },
    {
        "fontName": "Jumping Unicorn",
        "fontKey": "JumpingUnicorn"
    },
    {
        "fontName": "Just Married",
        "fontKey": "JustMarried"
    },
    {
        "fontName": "Justnithe",
        "fontKey": "Justnithe"
    },
    {
        "fontName": "JustnitheITALIC",
        "fontKey": "JustnitheItalic"
    },
    {
        "fontName": "KOCHI",
        "fontKey": "Kochi"
    },
    {
        "fontName": "KURATO",
        "fontKey": "Kurato"
    },
    {
        "fontName": "Kadupul Flowers",
        "fontKey": "KadupulFlowers"
    },
    {
        "fontName": "Kaliurang Signature",
        "fontKey": "KaliurangSignature"
    },
    {
        "fontName": "Kanaya",
        "fontKey": "Kanaya"
    },
    {
        "fontName": "Kawaii",
        "fontKey": "Kawaii"
    },
    {
        "fontName": "Keshia",
        "fontKey": "Keshia"
    },
    {
        "fontName": "Kids Zone Inner",
        "fontKey": "KidsZoneInner"
    },
    {
        "fontName": "Kids Zone Shadow",
        "fontKey": "KidsZoneShadow"
    },
    {
        "fontName": "Kids Zone",
        "fontKey": "KidsZone"
    },
    {
        "fontName": "Kids",
        "fontKey": "Kids"
    },
    {
        "fontName": "Krisan",
        "fontKey": "Krisan"
    },
    {
        "fontName": "Ladysta",
        "fontKey": "Ladysta"
    },
    {
        "fontName": "Latisha",
        "fontKey": "Latisha"
    },
    {
        "fontName": "Laureta",
        "fontKey": "Laureta"
    },
    {
        "fontName": "Lemon Dreams",
        "fontKey": "LemonDreams"
    },
    {
        "fontName": "LettersFont",
        "fontKey": "LettersFont"
    },
    {
        "fontName": "LifeLove",
        "fontKey": "LifeLove"
    },
    {
        "fontName": "Lightning Bolt",
        "fontKey": "LightningBolt"
    },
    {
        "fontName": "Lightning Script",
        "fontKey": "LightningScript"
    },
    {
        "fontName": "Lingstone OT",
        "fontKey": "LingstoneOt"
    },
    {
        "fontName": "Lingstone TT",
        "fontKey": "LingstoneTt"
    },
    {
        "fontName": "Little Comet Bubling",
        "fontKey": "LittleCometBubling"
    },
    {
        "fontName": "Little Comet",
        "fontKey": "LittleComet"
    },
    {
        "fontName": "Love Rose",
        "fontKey": "LoveRose"
    },
    {
        "fontName": "Love Twist Sans",
        "fontKey": "LoveTwistSans"
    },
    {
        "fontName": "Love Twist",
        "fontKey": "LoveTwist"
    },
    {
        "fontName": "Love moment",
        "fontKey": "LoveMoment"
    },
    {
        "fontName": "Lovebird",
        "fontKey": "Lovebird"
    },
    {
        "fontName": "Lusya",
        "fontKey": "Lusya"
    },
    {
        "fontName": "Lyodra",
        "fontKey": "Lyodra"
    },
    {
        "fontName": "MONOGRAM",
        "fontKey": "Monogram"
    },
    {
        "fontName": "MONOGRAM02",
        "fontKey": "Monogram02"
    },
    {
        "fontName": "MONOGRAM03",
        "fontKey": "Monogram03"
    },
    {
        "fontName": "MONOGRAM04",
        "fontKey": "Monogram04"
    },
    {
        "fontName": "MONOGRAM05",
        "fontKey": "Monogram05"
    },
    {
        "fontName": "MONOGRAM06",
        "fontKey": "Monogram06"
    },
    {
        "fontName": "MONOGRAM07",
        "fontKey": "Monogram07"
    },
    {
        "fontName": "MONOGRAM08",
        "fontKey": "Monogram08"
    },
    {
        "fontName": "MONOGRAM09",
        "fontKey": "Monogram09"
    },
    {
        "fontName": "MONOGRAM10",
        "fontKey": "Monogram10"
    },
    {
        "fontName": "MONOGRAM11",
        "fontKey": "Monogram11"
    },
    {
        "fontName": "MONOGRAM12",
        "fontKey": "Monogram12"
    },
    {
        "fontName": "MONOGRAM13",
        "fontKey": "Monogram13"
    },
    {
        "fontName": "MONOGRAM14",
        "fontKey": "Monogram14"
    },
    {
        "fontName": "MONOGRAM15",
        "fontKey": "Monogram15"
    },
    {
        "fontName": "Maddison",
        "fontKey": "Maddison"
    },
    {
        "fontName": "Made In Usa",
        "fontKey": "MadeInUsa"
    },
    {
        "fontName": "MagicUnicornRegular",
        "fontKey": "MagicUnicornRegular"
    },
    {
        "fontName": "Magno Regular",
        "fontKey": "MagnoRegular"
    },
    {
        "fontName": "Magnolie",
        "fontKey": "Magnolie"
    },
    {
        "fontName": "Mahacara",
        "fontKey": "Mahacara"
    },
    {
        "fontName": "Mahaputra",
        "fontKey": "Mahaputra"
    },
    {
        "fontName": "Maliska Script",
        "fontKey": "MaliskaScript"
    },
    {
        "fontName": "Malista Script 1",
        "fontKey": "MalistaScript1"
    },
    {
        "fontName": "Malista Script",
        "fontKey": "MalistaScript"
    },
    {
        "fontName": "Malista",
        "fontKey": "Malista"
    },
    {
        "fontName": "Manover",
        "fontKey": "Manover"
    },
    {
        "fontName": "Marceila",
        "fontKey": "Marceila"
    },
    {
        "fontName": "Margrave",
        "fontKey": "Margrave"
    },
    {
        "fontName": "Margraveregular",
        "fontKey": "Margraveregular"
    },
    {
        "fontName": "Marinthea",
        "fontKey": "Marinthea"
    },
    {
        "fontName": "MarintheaItalic",
        "fontKey": "MarintheaItalic"
    },
    {
        "fontName": "Masterday Shadow",
        "fontKey": "MasterdayShadow"
    },
    {
        "fontName": "Masterday",
        "fontKey": "Masterday"
    },
    {
        "fontName": "Mathella",
        "fontKey": "Mathella"
    },
    {
        "fontName": "Mathilda",
        "fontKey": "Mathilda"
    },
    {
        "fontName": "MathildaItalic",
        "fontKey": "MathildaItalic"
    },
    {
        "fontName": "Mattalia",
        "fontKey": "Mattalia"
    },
    {
        "fontName": "Mayla",
        "fontKey": "Mayla"
    },
    {
        "fontName": "Mazeline",
        "fontKey": "Mazeline"
    },
    {
        "fontName": "Melinda",
        "fontKey": "Melinda"
    },
    {
        "fontName": "Melodious",
        "fontKey": "Melodious"
    },
    {
        "fontName": "Meows",
        "fontKey": "Meows"
    },
    {
        "fontName": "Mermaid Dingbats",
        "fontKey": "MermaidDingbats"
    },
    {
        "fontName": "Mermaid",
        "fontKey": "Mermaid"
    },
    {
        "fontName": "Miabella",
        "fontKey": "Miabella"
    },
    {
        "fontName": "Milk And Honey",
        "fontKey": "MilkAndHoney"
    },
    {
        "fontName": "Milsey",
        "fontKey": "Milsey"
    },
    {
        "fontName": "Minimalist",
        "fontKey": "Minimalist"
    },
    {
        "fontName": "Mixy Missy Bubble",
        "fontKey": "MixyMissyBubble"
    },
    {
        "fontName": "Mixy Missy Dot",
        "fontKey": "MixyMissyDot"
    },
    {
        "fontName": "Mixy Missy Drop",
        "fontKey": "MixyMissyDrop"
    },
    {
        "fontName": "Mixy Missy Fire",
        "fontKey": "MixyMissyFire"
    },
    {
        "fontName": "Mixy Missy Inline",
        "fontKey": "MixyMissyInline"
    },
    {
        "fontName": "Mixy Missy Outline",
        "fontKey": "MixyMissyOutline"
    },
    {
        "fontName": "Mixy Missy Rope",
        "fontKey": "MixyMissyRope"
    },
    {
        "fontName": "Mixy Missy Sans",
        "fontKey": "MixyMissySans"
    },
    {
        "fontName": "Mixy Missy Shadow",
        "fontKey": "MixyMissyShadow"
    },
    {
        "fontName": "Mixy Missy Slab",
        "fontKey": "MixyMissySlab"
    },
    {
        "fontName": "Mixy Missy Speed",
        "fontKey": "MixyMissySpeed"
    },
    {
        "fontName": "Mixy Missy",
        "fontKey": "MixyMissy"
    },
    {
        "fontName": "Mobilesta",
        "fontKey": "Mobilesta"
    },
    {
        "fontName": "Mochaciattos 1",
        "fontKey": "Mochaciattos1"
    },
    {
        "fontName": "Mochaciattos",
        "fontKey": "Mochaciattos"
    },
    {
        "fontName": "Monday Groovy",
        "fontKey": "MondayGroovy"
    },
    {
        "fontName": "Monella",
        "fontKey": "Monella"
    },
    {
        "fontName": "MonogramBeauty",
        "fontKey": "MonogramBeauty"
    },
    {
        "fontName": "MonogramBeautyName",
        "fontKey": "MonogramBeautyName"
    },
    {
        "fontName": "Monstero",
        "fontKey": "Monstero"
    },
    {
        "fontName": "Montine Script",
        "fontKey": "MontineScript"
    },
    {
        "fontName": "Moonlight",
        "fontKey": "Moonlight"
    },
    {
        "fontName": "Mordane",
        "fontKey": "Mordane"
    },
    {
        "fontName": "Moris Line",
        "fontKey": "MorisLine"
    },
    {
        "fontName": "Moris",
        "fontKey": "Moris"
    },
    {
        "fontName": "MorningQuotes",
        "fontKey": "MorningQuotes"
    },
    {
        "fontName": "Motherblood",
        "fontKey": "Motherblood"
    },
    {
        "fontName": "Mullet",
        "fontKey": "Mullet"
    },
    {
        "fontName": "Myfirstfont",
        "fontKey": "Myfirstfont"
    },
    {
        "fontName": "NEVERQUIT",
        "fontKey": "Neverquit"
    },
    {
        "fontName": "NOPELIA MOMENT",
        "fontKey": "NopeliaMoment"
    },
    {
        "fontName": "Nectarine",
        "fontKey": "Nectarine"
    },
    {
        "fontName": "Nephillya",
        "fontKey": "Nephillya"
    },
    {
        "fontName": "Net World",
        "fontKey": "NetWorld"
    },
    {
        "fontName": "NewHopes",
        "fontKey": "NewHopes"
    },
    {
        "fontName": "Night Mare Dingbats",
        "fontKey": "NightMareDingbats"
    },
    {
        "fontName": "NightMareRegular",
        "fontKey": "NightMareRegular"
    },
    {
        "fontName": "Nighty OTF",
        "fontKey": "NightyOtf"
    },
    {
        "fontName": "Nighty TTF",
        "fontKey": "NightyTtf"
    },
    {
        "fontName": "NothingIsImpossible",
        "fontKey": "NothingIsImpossible"
    },
    {
        "fontName": "Ns Drippy Ttf 1",
        "fontKey": "NsDrippyTtf1"
    },
    {
        "fontName": "NsBlackbooksVictorian",
        "fontKey": "NsBlackbooksVictorian"
    },
    {
        "fontName": "Nuri Bold",
        "fontKey": "NuriBold"
    },
    {
        "fontName": "Nuri",
        "fontKey": "Nuri"
    },
    {
        "fontName": "Oink Blocky Regular",
        "fontKey": "OinkBlockyRegular"
    },
    {
        "fontName": "Oink Outline Regular",
        "fontKey": "OinkOutlineRegular"
    },
    {
        "fontName": "Onion",
        "fontKey": "Onion"
    },
    {
        "fontName": "Oops",
        "fontKey": "Oops"
    },
    {
        "fontName": "Outline",
        "fontKey": "Outline"
    },
    {
        "fontName": "Outside",
        "fontKey": "Outside"
    },
    {
        "fontName": "Paint Splashes Blue",
        "fontKey": "PaintSplashesBlue"
    },
    {
        "fontName": "Paint Splashes Green",
        "fontKey": "PaintSplashesGreen"
    },
    {
        "fontName": "Paint Splashes Rainbow",
        "fontKey": "PaintSplashesRainbow"
    },
    {
        "fontName": "Paint Splashes Regular",
        "fontKey": "PaintSplashesRegular"
    },
    {
        "fontName": "Pantry",
        "fontKey": "Pantry"
    },
    {
        "fontName": "PaperCandyRegular",
        "fontKey": "PaperCandyRegular"
    },
    {
        "fontName": "Paradise",
        "fontKey": "Paradise"
    },
    {
        "fontName": "Paw Wow Block",
        "fontKey": "PawWowBlock"
    },
    {
        "fontName": "Paw Wow Clipart",
        "fontKey": "PawWowClipart"
    },
    {
        "fontName": "Paw Wow Outline",
        "fontKey": "PawWowOutline"
    },
    {
        "fontName": "Paw Wow",
        "fontKey": "PawWow"
    },
    {
        "fontName": "Pax Suyud Bold",
        "fontKey": "PaxSuyudBold"
    },
    {
        "fontName": "Pax Suyud",
        "fontKey": "PaxSuyud"
    },
    {
        "fontName": "Pearly",
        "fontKey": "Pearly"
    },
    {
        "fontName": "Pink Vibes Sans",
        "fontKey": "PinkVibesSans"
    },
    {
        "fontName": "Pink Vibes",
        "fontKey": "PinkVibes"
    },
    {
        "fontName": "Pirates",
        "fontKey": "Pirates"
    },
    {
        "fontName": "Pixel Bit",
        "fontKey": "PixelBit"
    },
    {
        "fontName": "Playlines Line",
        "fontKey": "PlaylinesLine"
    },
    {
        "fontName": "Playlines",
        "fontKey": "Playlines"
    },
    {
        "fontName": "Qonitya",
        "fontKey": "Qonitya"
    },
    {
        "fontName": "Queen Italic",
        "fontKey": "QueenItalic"
    },
    {
        "fontName": "Queen",
        "fontKey": "Queen"
    },
    {
        "fontName": "Quentara",
        "fontKey": "Quentara"
    },
    {
        "fontName": "Quiltix Block",
        "fontKey": "QuiltixBlock"
    },
    {
        "fontName": "Quiltix",
        "fontKey": "Quiltix"
    },
    {
        "fontName": "Rabitta",
        "fontKey": "Rabitta"
    },
    {
        "fontName": "Rachel",
        "fontKey": "Rachel"
    },
    {
        "fontName": "Rainbow After Rain Regular",
        "fontKey": "RainbowAfterRainRegular"
    },
    {
        "fontName": "Rainbow After Rain Sans",
        "fontKey": "RainbowAfterRainSans"
    },
    {
        "fontName": "Rainbow After Rain",
        "fontKey": "RainbowAfterRain"
    },
    {
        "fontName": "Rainbow Sans Bold",
        "fontKey": "RainbowSansBold"
    },
    {
        "fontName": "Rainbow Sans",
        "fontKey": "RainbowSans"
    },
    {
        "fontName": "Rainbow Serif Bold",
        "fontKey": "RainbowSerifBold"
    },
    {
        "fontName": "Rainbow Serif",
        "fontKey": "RainbowSerif"
    },
    {
        "fontName": "RainbowChristmas",
        "fontKey": "RainbowChristmas"
    },
    {
        "fontName": "RainbowChristmasItalic",
        "fontKey": "RainbowChristmasItalic"
    },
    {
        "fontName": "RangersFONT",
        "fontKey": "RangersFont"
    },
    {
        "fontName": "RangersFONTHollow",
        "fontKey": "RangersFontHollow"
    },
    {
        "fontName": "RangersFONTItalic",
        "fontKey": "RangersFontItalic"
    },
    {
        "fontName": "Rasputia",
        "fontKey": "Rasputia"
    },
    {
        "fontName": "Restylia TT",
        "fontKey": "RestyliaTt"
    },
    {
        "fontName": "Retro Groovy Line",
        "fontKey": "RetroGroovyLine"
    },
    {
        "fontName": "Retro Groovy",
        "fontKey": "RetroGroovy"
    },
    {
        "fontName": "Retro Vibes",
        "fontKey": "RetroVibes"
    },
    {
        "fontName": "Retroking Rough",
        "fontKey": "RetrokingRough"
    },
    {
        "fontName": "Retroking",
        "fontKey": "Retroking"
    },
    {
        "fontName": "Revalate",
        "fontKey": "Revalate"
    },
    {
        "fontName": "ReverieSans Regular",
        "fontKey": "ReverieSansRegular"
    },
    {
        "fontName": "Rihana",
        "fontKey": "Rihana"
    },
    {
        "fontName": "Rockstyle",
        "fontKey": "Rockstyle"
    },
    {
        "fontName": "RockstyleITALIC",
        "fontKey": "RockstyleItalic"
    },
    {
        "fontName": "Romenia",
        "fontKey": "Romenia"
    },
    {
        "fontName": "Rotgohe",
        "fontKey": "Rotgohe"
    },
    {
        "fontName": "Rotters",
        "fontKey": "Rotters"
    },
    {
        "fontName": "Rougher",
        "fontKey": "Rougher"
    },
    {
        "fontName": "Roxer Brush",
        "fontKey": "RoxerBrush"
    },
    {
        "fontName": "Royal King Clean",
        "fontKey": "RoyalKingClean"
    },
    {
        "fontName": "Royal King",
        "fontKey": "RoyalKing"
    },
    {
        "fontName": "Rustic Pantry",
        "fontKey": "RusticPantry"
    },
    {
        "fontName": "SHELLIA MONOGRAM",
        "fontKey": "ShelliaMonogram"
    },
    {
        "fontName": "Safiar-Signature",
        "fontKey": "SafiarSignature"
    },
    {
        "fontName": "Safiar",
        "fontKey": "Safiar"
    },
    {
        "fontName": "Sakamoto",
        "fontKey": "Sakamoto"
    },
    {
        "fontName": "Salminah",
        "fontKey": "Salminah"
    },
    {
        "fontName": "Seattle",
        "fontKey": "Seattle"
    },
    {
        "fontName": "Secret Darling",
        "fontKey": "SecretDarling"
    },
    {
        "fontName": "Shadow",
        "fontKey": "Shadow"
    },
    {
        "fontName": "Shafiqa",
        "fontKey": "Shafiqa"
    },
    {
        "fontName": "Shafira",
        "fontKey": "Shafira"
    },
    {
        "fontName": "Shanela",
        "fontKey": "Shanela"
    },
    {
        "fontName": "Shaquilla",
        "fontKey": "Shaquilla"
    },
    {
        "fontName": "Sherley",
        "fontKey": "Sherley"
    },
    {
        "fontName": "Silentha OT",
        "fontKey": "SilenthaOt"
    },
    {
        "fontName": "Silentha TT",
        "fontKey": "SilenthaTt"
    },
    {
        "fontName": "Silky Candy",
        "fontKey": "SilkyCandy"
    },
    {
        "fontName": "Simbok Pudjie Decorative",
        "fontKey": "SimbokPudjieDecorative"
    },
    {
        "fontName": "Simbok Pudjie",
        "fontKey": "SimbokPudjie"
    },
    {
        "fontName": "Slatter",
        "fontKey": "Slatter"
    },
    {
        "fontName": "Slime Dripping",
        "fontKey": "SlimeDripping"
    },
    {
        "fontName": "Slime",
        "fontKey": "Slime"
    },
    {
        "fontName": "Smack Boom Extrude",
        "fontKey": "SmackBoomExtrude"
    },
    {
        "fontName": "Smack Boom",
        "fontKey": "SmackBoom"
    },
    {
        "fontName": "Smash Wall",
        "fontKey": "SmashWall"
    },
    {
        "fontName": "Smiletone",
        "fontKey": "Smiletone"
    },
    {
        "fontName": "Smooth Butter Clean",
        "fontKey": "SmoothButterClean"
    },
    {
        "fontName": "Smooth Butter",
        "fontKey": "SmoothButter"
    },
    {
        "fontName": "Somelove",
        "fontKey": "Somelove"
    },
    {
        "fontName": "SomeloveItalic",
        "fontKey": "SomeloveItalic"
    },
    {
        "fontName": "Soulmate",
        "fontKey": "Soulmate"
    },
    {
        "fontName": "SouthTown",
        "fontKey": "SouthTown"
    },
    {
        "fontName": "Sparkling",
        "fontKey": "Sparkling"
    },
    {
        "fontName": "Spicy Chicken",
        "fontKey": "SpicyChicken"
    },
    {
        "fontName": "Spirly",
        "fontKey": "Spirly"
    },
    {
        "fontName": "Splashy Rainbow Doodles",
        "fontKey": "SplashyRainbowDoodles"
    },
    {
        "fontName": "Splashy Rainbow",
        "fontKey": "SplashyRainbow"
    },
    {
        "fontName": "SpookyHunter",
        "fontKey": "SpookyHunter"
    },
    {
        "fontName": "SpookyHunterItalic",
        "fontKey": "SpookyHunterItalic"
    },
    {
        "fontName": "Spring Script 1",
        "fontKey": "SpringScript1"
    },
    {
        "fontName": "Spring Script 2",
        "fontKey": "SpringScript2"
    },
    {
        "fontName": "Spring Script 3",
        "fontKey": "SpringScript3"
    },
    {
        "fontName": "Spring Script 4",
        "fontKey": "SpringScript4"
    },
    {
        "fontName": "Springbee",
        "fontKey": "Springbee"
    },
    {
        "fontName": "Srianty",
        "fontKey": "Srianty"
    },
    {
        "fontName": "Stasya",
        "fontKey": "Stasya"
    },
    {
        "fontName": "Stay Groov Regular",
        "fontKey": "StayGroovRegular"
    },
    {
        "fontName": "Stepira",
        "fontKey": "Stepira"
    },
    {
        "fontName": "Sticky Planner Regular",
        "fontKey": "StickyPlannerRegular"
    },
    {
        "fontName": "Sticky Planner Script Regular",
        "fontKey": "StickyPlannerScriptRegular"
    },
    {
        "fontName": "Stranger Creature",
        "fontKey": "StrangerCreature"
    },
    {
        "fontName": "Street Eagle",
        "fontKey": "StreetEagle"
    },
    {
        "fontName": "Street Road Clean",
        "fontKey": "StreetRoadClean"
    },
    {
        "fontName": "Street Road",
        "fontKey": "StreetRoad"
    },
    {
        "fontName": "Strip Deco Standard",
        "fontKey": "StripDecoStandard"
    },
    {
        "fontName": "Strip Deco",
        "fontKey": "StripDeco"
    },
    {
        "fontName": "Sugako",
        "fontKey": "Sugako"
    },
    {
        "fontName": "SummerHoliday",
        "fontKey": "SummerHoliday"
    },
    {
        "fontName": "Sunshine Flower Bold",
        "fontKey": "SunshineFlowerBold"
    },
    {
        "fontName": "Sunshine Flower Extras",
        "fontKey": "SunshineFlowerExtras"
    },
    {
        "fontName": "Sunshine Flower Script Bold",
        "fontKey": "SunshineFlowerScriptBold"
    },
    {
        "fontName": "Sunshine Flower Script",
        "fontKey": "SunshineFlowerScript"
    },
    {
        "fontName": "Sunshine Flower",
        "fontKey": "SunshineFlower"
    },
    {
        "fontName": "Super Black",
        "fontKey": "SuperBlack"
    },
    {
        "fontName": "Super Outline",
        "fontKey": "SuperOutline"
    },
    {
        "fontName": "Sweden Love",
        "fontKey": "SwedenLove"
    },
    {
        "fontName": "Sweet christmas",
        "fontKey": "SweetChristmas"
    },
    {
        "fontName": "Sweetie Romance Sans",
        "fontKey": "SweetieRomanceSans"
    },
    {
        "fontName": "Sweetie Romance",
        "fontKey": "SweetieRomance"
    },
    {
        "fontName": "SweetyLover",
        "fontKey": "SweetyLover"
    },
    {
        "fontName": "Sweetyhearts",
        "fontKey": "Sweetyhearts"
    },
    {
        "fontName": "Tashia",
        "fontKey": "Tashia"
    },
    {
        "fontName": "Texas Walls",
        "fontKey": "TexasWalls"
    },
    {
        "fontName": "Thanksmom",
        "fontKey": "Thanksmom"
    },
    {
        "fontName": "The American Family",
        "fontKey": "TheAmericanFamily"
    },
    {
        "fontName": "The Billion Monoline",
        "fontKey": "TheBillionMonoline"
    },
    {
        "fontName": "The Billion",
        "fontKey": "TheBillion"
    },
    {
        "fontName": "The Doctor",
        "fontKey": "TheDoctor"
    },
    {
        "fontName": "The Skylar 2",
        "fontKey": "TheSkylar2"
    },
    {
        "fontName": "The Ultimate Class",
        "fontKey": "TheUltimateClass"
    },
    {
        "fontName": "TheCircusShow-CenterDot",
        "fontKey": "TheCircusShowCenterDot"
    },
    {
        "fontName": "TheCircusShow-Dot",
        "fontKey": "TheCircusShowDot"
    },
    {
        "fontName": "TheCircusShow-Line",
        "fontKey": "TheCircusShowLine"
    },
    {
        "fontName": "TheCircusShow",
        "fontKey": "TheCircusShow"
    },
    {
        "fontName": "TheExcited",
        "fontKey": "TheExcited"
    },
    {
        "fontName": "Therlalu Rough",
        "fontKey": "TherlaluRough"
    },
    {
        "fontName": "Therlalu",
        "fontKey": "Therlalu"
    },
    {
        "fontName": "Thickline",
        "fontKey": "Thickline"
    },
    {
        "fontName": "Twinkling Stars Script",
        "fontKey": "TwinklingStarsScript"
    },
    {
        "fontName": "Twinkling Stars",
        "fontKey": "TwinklingStars"
    },
    {
        "fontName": "Ultimate Slayer",
        "fontKey": "UltimateSlayer"
    },
    {
        "fontName": "Urban Melted Extrude",
        "fontKey": "UrbanMeltedExtrude"
    },
    {
        "fontName": "Urban Melted",
        "fontKey": "UrbanMelted"
    },
    {
        "fontName": "Valentijn",
        "fontKey": "Valentijn"
    },
    {
        "fontName": "Valesta",
        "fontKey": "Valesta"
    },
    {
        "fontName": "ValestaItalic",
        "fontKey": "ValestaItalic"
    },
    {
        "fontName": "Vanetta",
        "fontKey": "Vanetta"
    },
    {
        "fontName": "Vegan",
        "fontKey": "Vegan"
    },
    {
        "fontName": "Vibes",
        "fontKey": "Vibes"
    },
    {
        "fontName": "Victim Power",
        "fontKey": "VictimPower"
    },
    {
        "fontName": "Viktoria Monogram 2",
        "fontKey": "ViktoriaMonogram2"
    },
    {
        "fontName": "Viktoria Monogram",
        "fontKey": "ViktoriaMonogram"
    },
    {
        "fontName": "Village Rabigen Bold Slant",
        "fontKey": "VillageRabigenBoldSlant"
    },
    {
        "fontName": "Village Rabigen Bold",
        "fontKey": "VillageRabigenBold"
    },
    {
        "fontName": "Village Rabigen Slant",
        "fontKey": "VillageRabigenSlant"
    },
    {
        "fontName": "Village Rabigen",
        "fontKey": "VillageRabigen"
    },
    {
        "fontName": "Vintage Avocado",
        "fontKey": "VintageAvocado"
    },
    {
        "fontName": "Vintage Party",
        "fontKey": "VintageParty"
    },
    {
        "fontName": "Vintage Queens",
        "fontKey": "VintageQueens"
    },
    {
        "fontName": "VioletheFONT",
        "fontKey": "VioletheFont"
    },
    {
        "fontName": "VioletheFONTItalic",
        "fontKey": "VioletheFontItalic"
    },
    {
        "fontName": "Virginia",
        "fontKey": "Virginia"
    },
    {
        "fontName": "Visaka",
        "fontKey": "Visaka"
    },
    {
        "fontName": "Waffle Latte Bold Italic",
        "fontKey": "WaffleLatteBoldItalic"
    },
    {
        "fontName": "Waffle Latte Bold",
        "fontKey": "WaffleLatteBold"
    },
    {
        "fontName": "Waffle Latte Italic",
        "fontKey": "WaffleLatteItalic"
    },
    {
        "fontName": "Waffle Latte Rough Bold Italic",
        "fontKey": "WaffleLatteRoughBoldItalic"
    },
    {
        "fontName": "Waffle Latte Rough Bold",
        "fontKey": "WaffleLatteRoughBold"
    },
    {
        "fontName": "Waffle Latte Rough Italic",
        "fontKey": "WaffleLatteRoughItalic"
    },
    {
        "fontName": "Waffle Latte Rough",
        "fontKey": "WaffleLatteRough"
    },
    {
        "fontName": "Waffle Latte",
        "fontKey": "WaffleLatte"
    },
    {
        "fontName": "Wallner",
        "fontKey": "Wallner"
    },
    {
        "fontName": "Warilah",
        "fontKey": "Warilah"
    },
    {
        "fontName": "Water Orange",
        "fontKey": "WaterOrange"
    },
    {
        "fontName": "Watermelon Sugar",
        "fontKey": "WatermelonSugar"
    },
    {
        "fontName": "Watermelon",
        "fontKey": "Watermelon"
    },
    {
        "fontName": "WeLoveMom",
        "fontKey": "WeLoveMom"
    },
    {
        "fontName": "West Kingdom",
        "fontKey": "WestKingdom"
    },
    {
        "fontName": "Whilona Script",
        "fontKey": "WhilonaScript"
    },
    {
        "fontName": "Whilona Type",
        "fontKey": "WhilonaType"
    },
    {
        "fontName": "Whitney",
        "fontKey": "Whitney"
    },
    {
        "fontName": "Wild Plants",
        "fontKey": "WildPlants"
    },
    {
        "fontName": "WillowRegular",
        "fontKey": "WillowRegular"
    },
    {
        "fontName": "Wolfriend",
        "fontKey": "Wolfriend"
    },
    {
        "fontName": "YOGA",
        "fontKey": "Yoga"
    },
    {
        "fontName": "Yesie",
        "fontKey": "Yesie"
    },
    {
        "fontName": "Yogyakarta",
        "fontKey": "Yogyakarta"
    },
    {
        "fontName": "Yuanita",
        "fontKey": "Yuanita"
    },
    {
        "fontName": "Yustia",
        "fontKey": "Yustia"
    },
    {
        "fontName": "Zahiya",
        "fontKey": "Zahiya"
    }
];

export const FONT_NAME_LIST = _.map(FONT_FAMILY_LIST, 'fontName');

